module.exports = {"220702001":"团结街道","220702002":"文化街道","220702003":"民主街道","220702004":"临江街道","220702005":"新区街道","220702006":"前进街道","220702007":"和平街道","220702008":"工农街道","220702009":"沿江街道","220702010":"铁西街道","220702011":"繁荣街道","220702012":"建设街道","220702013":"石化街道","220702014":"伯都讷街道","220702015":"长宁街道","220702016":"滨江街道","220702017":"镜湖街道","220702100":"大洼镇","220702101":"善友镇","220702102":"毛都站镇","220702103":"哈达山镇","220702200":"新城乡","220702202":"伯都乡","220702400":"华侨农场","220702401":"大洼商业渔场","220702402":"国营善友林场","220702403":"国营八家子苗圃","220702404":"良种繁育场","220702405":"哈达山林场","220702406":"雅达虹工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220702.json
// module id = 741
// module chunks = 0